import * as React from 'react'
import kebabCase from 'lodash/kebabCase'
import { TERMS_AND_CONDITIONS_BODY_CONTENT } from './constants';


export const Body = ({ locale }: { locale: string }) => {
  const bodyContent = TERMS_AND_CONDITIONS_BODY_CONTENT[locale] ?? TERMS_AND_CONDITIONS_BODY_CONTENT.en;

  return (
    <div className="terms-body py-10 lg:pb-24 lg:pt-32 m-auto lg:max-w-5xl text-kale text-base lg:text-xl">
      <h1 className="text-mxl lg:text-6xl font-heading mb-5 lg:mb-9">{bodyContent.title}</h1>
      <p className="mb-4 font-medium text-xl">{bodyContent.date}</p>
      {bodyContent.description.map((paragraph, i) => {
        return (
          <p
            key={i}
            className="mb-4 font-light"
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        )
      })}
      <section>
        <h2 className="text-2xl lg:text-3xl font-heading mb-5 lg:mb-9">Table of contents</h2>
        <ol>
          {bodyContent.body.map((section) => {
            const titleId = kebabCase(section.title)
            return (
              <li key={titleId}>
                <a className="mb-3 lg:mb-5 font-heading font-medium" href={`#${titleId}`}>{section.title}</a>
              </li>
            )
          })}
        </ol>
      </section>
      {bodyContent.body.map((section, i) => {
        const titleId = kebabCase(section.title)
        return (
          <div key={i}>
            <h2 id={titleId} className="mt-12 mb-3 lg:mb-5 font-heading font-medium text-mlg lg:text-hxl">
              <a href={`#${titleId}`}>{section.title}</a>
            </h2>
            {section.paragraphs.map((value, y) => {
              return (
                <p
                  key={y}
                  className="font-light mb-4 text-sm lg:text-lg"
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

